import { render, staticRenderFns } from "./traveler-icon.vue?vue&type=template&id=4e6a4448&scoped=true&"
import script from "./traveler-icon.vue?vue&type=script&lang=js&"
export * from "./traveler-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6a4448",
  null
  
)

export default component.exports